/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */
import { TasksApi } from "client";
import { Const } from "const";
import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useApproveTask } from "hooks/ApproveTaskHook";
import { useCallApi } from "hooks/CallApiHook";
import { useCallback, useState } from "react";

export const useDeleteMultipleChargeTasks = () => {
  const [deleteJobsetId, setDeleteJobsetId] = useState<string>();
  const { requestApprove, cancelApprove } = useApproveTask();
  const [api, canceler] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.deleteTask
  );

  const cancelCallback = useCallback(() => {
    cancelApprove();
    canceler();
  }, [cancelApprove, canceler]);

  const result = useCallApi(
    async () => {
      if (deleteJobsetId !== undefined) {
        // Deny jobset
        await requestApprove({
          jobSetApproval: false,
          jobSetId: deleteJobsetId,
        });

        // Delete jobset
        await api.deleteTask({
          jobSetId: deleteJobsetId,
          taskKind: Const.taskKind.multipleCharge,
        });
      }
    },
    cancelCallback,
    [deleteJobsetId, api, requestApprove, cancelCallback]
  );
  return { ...result, setDeleteJobsetId };
};
